






































































































































































































































































































































































































































































































import Loading from 'vue-loading-overlay';
import { EventBus, TypeEventBus, sortObjectByPropertyName, getAlertColorByPriority, getDateFromDateFormatApi, getCurrentTime, substractTimeToDate, getNowNoFormat, getDateFormattedAsMoment, addItemToLocalStorage, StoregeKey, removeItemFromLocalStorage, existKeyInLocalStorage, getItemFromLocalStorage, getIndexFromList, addItemsToListIfAreNotAdded, tableSort } from '../../core/utils';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import { ContextMenu } from '../../core/components';
import { Destroyed } from '../../core/decorators';
import JourneyActions from "../components/JourneyActions.vue"
import ModalConfiguration from "../../home/components/ModalConfiguration.vue"
import ModalConfirmation from "../../home/components/ModalConfirmation.vue"
import ModalJourneyABM from "../../home/components/ModalJourneyABM.vue"
import Input from "../../core/components/Input.vue"
import SimpleTable from "../../core/components/SimpleTable.vue"
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import moment from 'moment';
import { JourneysService } from '../api/JourneysService';
import { SettingsService } from '../../settings/api/SettingsService';
import { FilterDateEvent } from '../../core/utils/types';
import {
    formatDate,
    getDateByFormat,
    getDateTimeFromYesterday,
    getDateTimeToYesterday,
    getDateTimeToToDay,
    getDateTimeFromToDay
} from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import { JourneysListHistoricalDataResponse, journeyHistorical, journeyRT } from '../models/JourneysList';
import {
    NAME_ROUTES,
    PRIVILEGE_KEYS,
    PRIVILEGE_TYPES
} from '../../core/utils';
import { generateExcel } from '../index';
import store, { AuthEvent, GetterType } from '../../../store';
import axios from 'axios'
import { dateTypes, diffOptions } from '../../core/models';

@Component({
    components: {
        Loading,
        ModalConfirmation,
        ModalConfiguration,
        ContextMenu,
        ModalJourneyABM,
        Button,
        JourneyActions,
        Input,
        SimpleTable
    }
})
export default class JourneysListPage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    sortBy: string[] = ['datetime_to'];
    sortDesc: boolean[] = [false];

    showModalAbm: boolean = false;
    showModalConfiguration: boolean = false;
    rightClickEvent: any = null;
    journeyCalcType: string = '';
    radioGroup: any = null;
    deletedJourneysByAdm: boolean = false;
    createdJourneysByAdm: boolean = false;
    showModalConfirmation: boolean = false;
    actionJourney: string = '';
    postJson: object = {};
    requestDate: boolean = false;
    requestDone: boolean = false;
    processingExcel: boolean = false;
    visibleModalJourneyActions: boolean = false;
    summaryData: object = {
        journeys: 0,
        alertas: 0,
        sin_procesar: 0,
        con_error: 0,
        abiertas: 0
    };
    dateFilter: any = {
        date: null,
        dateRange:null
    };
    cancelToken: any | null = null;
    headers: any[] = [];
    tableFilters: any = {};
    dateFrom: any = null;
    dateTo: any = null;
    menuDateFrom: boolean =  false;
    menuDateTo: boolean =  false;
    modal: boolean = false;
    menu2: boolean = false;
    hideAvailabilityColumn: boolean = false;
    hideDurationColumn: boolean = false;
    showContextMenu: boolean = false;
    journeySelected: any = 'null';
    filterAlertsSelected: any = 'null';
    journeySelectedFinished: any = 'null';
    pendingRequest: boolean = false;
    search: string = '';
    processedValue: any = 'null';
    availabilityFilterValue: any = 'null';
    contextMenuItem: any = [];
    countBus: number = 0;
    otsListHeader: object = {
        text: 'OTs',
        value: 'work_orders',
        sortable: false,
    }
    allHeaders: any[] = [
        {
            text: 'Chofer',
            value: 'driver',
            sortable: true
        },
        {
            text: 'Vehículo',
            value: 'vehicle',
            sortable: true
        },
        {
            ...this.otsListHeader
        },
        {
            text: 'Inicio',
            value: 'datetime_from'
        },
        {
            text: 'Fin',
            value: 'datetime_to',
        },
        {
            text: 'Procesada',
            value: 'processed',
            align: 'center',
            filter: this.processedFilter
        },
        {
            text: 'Alertas',
            value: 'summary',
            align: 'center',
            sortable: false,
            filter: this.filterAlerts
        },
        {
            text: 'Marcada con error',
            value: 'error',
            filter: this.filterJourneyError,
            class: 'th-mark-as-error',
            align: 'center',
        },
        {
            text: 'Disponibilidad',
            value: 'driver.availability',
            filter: this.availabilityFilter,
            align: 'start'
        },
        {
            text: '',
            value: 'finished',
            filter: this.filterJourneyFinished,
            sortable: false,
            class: 'hide-header'
        },
        {
            text: '',
            value: 'created',
            filter: this.filterCreatedJourneys,
            sortable: true,
            class: 'hide-header'
        },
        {
            text: '',
            value: 'deleted',
            filter: this.filterDeletedJourneys,
            sortable: true,
            class: 'hide-header'
        },
        {
            text: '',
            value: 'inconsistency',
            filter: this.filterJourneyInconsistent,
            sortable: false,
            class: "hide-header",
        }
    ];
    headersForOnlyViewPermission: any[] = [
        //chofer, vehiculo, inicio, fin y disponibilidad
        {
            text: 'Chofer',
            value: 'driver',
            sortable: true
        },
        {
            text: 'Vehículo',
            value: 'vehicle',
            sortable: true
        },
        {
            text: 'Inicio',
            value: 'datetime_from'
        },
        {
            text: 'Fin',
            value: 'datetime_to',
        },
        {
            text: 'Disponibilidad',
            value: 'driver.availability',
            filter: this.availabilityFilter,
            align: 'start'
        }
       
    ];
    headersTable: any[] = [...this.allHeaders];
    processedList: any = [
        {
            text: "Procesadas",
            value: "true"
        },
        {
            text: "Sin procesar",
            value: "false"
        },
        {
            text: "Todas",
            value: "null"
        }
    ];
    itemsFilterJourney: any = [
        {
            text: "Con error",
            value: "true"
        },
        {
            text: "Sin error",
            value: "false"
        },
        {
            text: "Todas",
            value: "null"
        }
    ];
    itemsFilterAlerts: any = [
        {
            text: "Con alertas",
            value: "1"
        },
        {
            text: "Sin alertas",
            value: "0"
        },
        {
            text: "Inconsistentes",
            value: "true"
        },
        {
            text: "Todas",
            value: "null"
        }
    ];
    itemsFilterJourneyFinished: any = [
        {
            text: "Finalizadas",
            value: "true"
        },
        {
            text: "Sin finalizar",
            value: "false"
        },
        {
            text: "Todas",
            value: "null"
        }
    ];
    availabilityList: any = [
        {
            text: "Disponible",
            value: "true"
        },
        {
            text: "No disponible",
            value: "false"
        },
        {
            text: "Todas",
            value: "null"
        }
    ];
    createdByAdmList: any = [
        {
            text: "Sólo creadas",
            value: "true"
        },
        {
            text: "Todas",
            value: "null"
        }
    ];
    createdByAdmValue: any = 'null';
    deletedByAdmList: any = [
        {
            text: "No eliminadas", //Blancas
            value: "false"
        },
        {
            text: "Sólo eliminadas", //Rojas
            value: "true"
        },
        {
            text: "Todas", //Rojas y blancas POR DEFECTO
            value: "null"
        }
    ];
    deletedByAdmValue: any = 'null';
    modalCrearJornada: object = {
        width: '1000',
        title: 'Alta Jornada',
        disclaimers: [
            'La creacion de la jornada por parte de la administración es responsabilidad de la misma.<br> Smartway no se responsabiliza por la consistencia de las jornadas a modificar, anteriores o posteriores.',
        ],
        form: {
            action: 'create',
            data: {
                driver: '',
                vehicle: null,
                dateStart: null,
                hourStart: null,
                dateEnd: null,
                hourEnd: null,
                simpleHours: {
                    hours: '00',
                    minutes: '00'
                },
                nightHours: {
                    hours: '00',
                    minutes: '00'
                },
                extraHours: {
                    hours: '00',
                    minutes: '00'
                },
                simplePresentHours: {
                    hours: '00',
                    minutes: '00'
                },
                overnightHours: {
                    hours: '00',
                    minutes: '00'
                }
            }
        },
        actions:[
            {
                name: 'Cancelar',
                color: 'error',
                action: 'close-modal'
            },
            {
                name: 'Crear',
                color: 'green',
                action: 'createJourney'
            }
        ]
    };
    pagination: object = {
      rowsPerPageItems: 12
    };
    dataTableHeight: number = 0;
    dataIsLoaded = false;
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;
    availableDriverText: string = 'DISPONIBLE';
    unavailableDriverText: string = 'NO DISPONIBLE';
    unsubscribe: () => void;

    get isMdpUser(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.MDP] == true;
    }

    get shouldSeeJourneyDetail(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.JOURNEY_ONLY_VIEW] == false;
    }

    created() {
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
            this.checkPermissions();
        });
    }

    checkPermissions() {
        if (!this.shouldReadJourneys) {
            this.$router.push(NAME_ROUTES.HOME.path);
        }
    }

    get shouldReadJourneys(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.READ)
    }

    getAvailabilityColor(item){
        if(item.driver.availability){
            if(item.deleted){
                return 'white'
            }else{
                return 'green'
            }
        }else{
            if(item.deleted){
                return 'white'
            }else{
                return 'red'
            }
        }
    }


    @Watch('$route', { immediate: true, deep: true })
    onUrlChange(newVal: any) {
        EventBus.$emit(TypeEventBus.CLOSE_DATERANGE_SELECTOR);
        this.$_closeNotification();
        EventBus.$emit(TypeEventBus.NOT_CALL_LAST_REPORT);
        if(this.$_getSelectedCompany){
            this.getDriversFromSelectedCompany();
        }
        if(this.$_getFilterDate == TypeFilterDate.RANGE_DATE){
            this.getJourneyDateRange();
        }else{
            if(this.$_getSelectedCompany){
                this.getJourneysList();
            }
        }
    }

    updateJourneysFromActions(res, journeysToUpdate){
        // console.log("updateJourneysFromActions res", res);
        // console.log("updateJourneysFromActions journeysToUpdate", journeysToUpdate);
        for(let i=0; i<journeysToUpdate.length; i++){
            let currentJourneyId = journeysToUpdate[i];
            let indexInJourneyList = getIndexFromList(this.journeys, 'id', currentJourneyId)
            if(indexInJourneyList !== -1){
               let currentEvent = res[currentJourneyId]['new_registry']['event'];
               switch(currentEvent){
                case 'PROCESSED':
                    this.$set(this.journeys[indexInJourneyList], 'processed', true);
                    break;
                case 'UNPROCESSED':
                    this.$set(this.journeys[indexInJourneyList], 'processed', false);
                    break;
                case 'ERROR':
                    this.$set(this.journeys[indexInJourneyList], 'error', true);
                    break;
                case 'NOERROR':
                    this.$set(this.journeys[indexInJourneyList], 'error', false);
                    break;
                case 'FINISHED':
                    this.$set(this.journeys[indexInJourneyList], 'closing', true);
                    // this.$set(this.journeys[indexInJourneyList], 'datetime_to', res[currentJourneyId]['new_registry']['date']);
                    this.$set(this.journeys[indexInJourneyList], 'finished', false);
                    break;
                case 'UNDELETED':
                    this.$set(this.journeys[indexInJourneyList], 'deleted', false);
                    break;
                case 'DELETED':
                    this.$set(this.journeys[indexInJourneyList], 'deleted', true);
                    break;
               } 
            }
        }
        this.clearSelectedJourneys();
    }
    updateSearch(value){
        this.search = value;
        this.saveFilterLocalStorage('journey_list_search', value)
    }
    updateSelectedJourneys(rows){
        this.selectedJourneys = rows;
    }

    clearSelectedJourneys(){
        this.selectedJourneys = [];
    }

    get getDataIsLoaded(){
        return this.dataIsLoaded
    }

    get getJourneys(){
        return this.journeys
    }

    closeContextMenu(){
        this.showContextMenu = false;
    }

    rightClickJourney(event, item){
        if(this.shouldSeeJourneyDetail){
            this.contextMenuItem = [];
            this.contextMenuItem.push(
                {
                    disabled: false,
                    title: 'Abrir en una nueva pestaña',
                    link: {
                            path: '/journeys/information/' + item.id,
                            target: '_blank'
                        }
                    },
                    
                );
            this.rightClickEvent = event;
            this.showContextMenu = true;
        }
    }

    getBadgeColor(){
        return getAlertColorByPriority()
    }

    clearFilter(item){
        if(item === 'procesadas'){
            this.processedValue = 'null'
            this.saveFilterLocalStorage('procesadas', 'null')
        }else if(item === 'finalizacion'){
            this.journeySelectedFinished = 'null'
            this.saveFilterLocalStorage('finalizadas', 'null')
        }else if(item === 'alertas'){
            this.filterAlertsSelected = 'null'
            this.saveFilterLocalStorage('alertas', 'null')
        }else if(item === 'con_error'){
            this.journeySelected = 'null'
            this.saveFilterLocalStorage('marcada_con_error', 'null')
        }else if(item === 'disponibilidad'){
            this.availabilityFilterValue = 'null'
            this.saveFilterLocalStorage('disponibilidad', 'null')
        }else if(item === 'creadas'){
            this.createdByAdmValue = 'null'
            this.saveFilterLocalStorage('creadas', 'null')
        }else if(item === 'eliminadas'){
            this.deletedByAdmValue = 'null'
            this.saveFilterLocalStorage('eliminadas', 'null')
        }
    }

    visibilityModalActions(value){
        this.visibleModalJourneyActions = value
    }

    modalAbmVisibility(value){
        this.showModalAbm = value;
        this.showModalConfirmation = false;
    }

    @Destroyed
    cancelTokens() {
        if (this.cancelToken) {
            this.cancelToken.cancel();
            this.cancelToken = null;
        }
        this.cancelToken = Axios.CancelToken.source();
    }

    resetFilters(){
        this.processedValue = 'null';
        this.journeySelected = 'null';
        this.journeySelectedFinished = 'null';
        this.filterAlertsSelected = 'null';
        this.deletedByAdmValue = "null";
        this.createdByAdmValue = "null";
        this.search = '';
        this.availabilityFilterValue = 'null';
        removeItemFromLocalStorage(StoregeKey.JOURNEYS_LIST_FILTERS);
    }

    get shouldCreateAndRead(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.EDIT_AND_DELETE) || this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.CREATE);
    }

    get availabilityColumn(){
        return this.hideAvailabilityColumn;
    }
    get durationColumn(){
        return this.hideDurationColumn;
    }

    submitJourney(){
        this.showModalConfirmation = false;
    }

    updateDataTableHeight () {
        let divParent = this.$refs.parentDiv as HTMLFormElement;
        this.dataTableHeight = divParent.clientHeight;
    }

    openConfirmationDialog(action){
        this.actionJourney = action;
        this.showModalConfirmation = true;
    }
    get computedHeaders(): any {
        let headers = this.headersTable;

        if(!this.shouldSeeJourneyDetail){
            headers = this.headersForOnlyViewPermission
        }
        if(!this.isMdpUser){
            headers = headers.filter(header => header.value !== 'work_orders')
        }
        if(this.availabilityColumn){
            headers = headers.filter(header => header.text !== "Disponibilidad")
        }

        if(this.durationColumn){
            headers = headers.filter(header => header.text !== "Duración")
        }

        return headers
    }



    summaryDataResponse: any = {
        journey_summary:{
            open: 0,
            unprocessed: 0,
            unprocessed_error:0,
            unprocessed_warning:{
                generic_tag: 0,
                max_journey_duration: 0,
                max_stop_duration: 0,
                min_driver_rest_duration: 0,
                total:0
            }
        }
    };
    summary: any = {};
    selectedJourneys: Array<object> = [];
    filteredJourneys: Array<object> = [];
    journeys: journeyHistorical[] | journeyRT[] = [];
    journeysIds: any[] = [];


    saveFilterLocalStorage(key, value) {
        this.tableFilters[key] = value;
        addItemToLocalStorage(StoregeKey.JOURNEYS_LIST_FILTERS, this.tableFilters);
    }

    filterTooltipsMessages(messages){
        if(messages !== undefined){
            let allMessages: any = [];
            for(let i=0; i<messages.length; i++){
                allMessages.push(messages[i].description);
            }
            allMessages = allMessages.filter(function(elem, index, self) {
                return index === self.indexOf(elem);
            });
            return allMessages.toString().replace(/,/g, ", ");
        }else{
            return "";
        }

    }

    updateFilteredJourneys(filteredItems){
        this.journeysIds = [];
        this.filteredJourneys = [];
        // console.log("filteredItems", filteredItems);
        this.saveJourneysData(filteredItems);
        this.filteredJourneys = filteredItems;
        if(filteredItems.length !== 0){
            this.journeysIds = filteredItems.map(function(journey){
                return journey['id']
            })
        }
    }

    seeJourney(item){
        if(this.shouldSeeJourneyDetail){
            this.$router.push({
                path: '/journeys/information/' + item
            })
        }
    }

    openModalConfiguration(){
        this.showModalConfiguration = true;
    }

    customSort(items: object[], sortBy: string[], sortDesc: boolean[]) {
       return tableSort(items, sortBy, sortDesc)
    }

    availabilityFilter(value) {
        // window.console.log(value);
        if(this.availabilityFilterValue == "null"){
            return true;
        }
        return value.toString() === this.availabilityFilterValue;
    }

    processedFilter(value) {
        if(this.processedValue == "null"){
            return true;
        }
        return value.toString() === this.processedValue;
    }

    filterJourneyError(value) {
        if(this.journeySelected == "null"){
            return true;
        }
        return value.toString() === this.journeySelected;
    }

    filterAlerts(value) {
        // Si el filtro está en inconsistentes o consistentes, lo dejamos pasar.
        if (this.filterAlertsSelected === "true") return true;
            if(this.filterAlertsSelected == "null"){
                return true;
            }
        return value.alerts.value.toString() === this.filterAlertsSelected;
    }

    filterJourneyInconsistent(value) {
        // Si el filtro NO está en inconsistentes, lo dejamos pasar.
        if (this.filterAlertsSelected !== "true") return true;    
            return value.toString() === this.filterAlertsSelected;
    }

    filterJourneyFinished(value) {
        if(this.journeySelectedFinished == "null"){
            return true;
        }
        return value.toString() === this.journeySelectedFinished;
    }

    filterDeletedJourneys(value) {
        if(this.deletedByAdmValue == "null"){
            return true;
        }
        return value.toString() === this.deletedByAdmValue;
    }

    filterCreatedJourneys(value) {
        if(this.createdByAdmValue == "null"){
            return true;
        }
        return value.toString() === this.createdByAdmValue;
    }

    customFilter(items, search, filter) {
        if (!search) return true;

        let userSearch = search.toString().toLowerCase().trim().replace(/\s+/g, ' ');
        let userSearchUpper = search.toString().toUpperCase().trim().replace(/\s+/g, ' ');
        let searchWords = userSearch.split(' ');

        const normalizePlate = (plate) => plate ? plate.toString().replace(/\s+/g, '').toUpperCase() : '';

        let vehicleMatch = filter.vehicle.some(vehicle =>
            normalizePlate(vehicle.vehicle_plate).includes(userSearchUpper) ||
            normalizePlate(vehicle.description).includes(userSearchUpper) || 
            (vehicle.vin && vehicle.vin.includes(userSearch))
        );

        let driverMatch = false;
        if (filter.driver.name) {
            let driverName = filter.driver.name.toLowerCase();
            driverMatch = searchWords.every(word => driverName.includes(word));
        }

        let workOrderMatch = filter.work_orders.length > 0 && 
                            filter.work_orders.some(order => order.toString().includes(userSearch));

        return driverMatch || vehicleMatch || workOrderMatch;
    }




    exportToExcel() {
        this.showModalConfirmation = false;
        this.processingExcel = true;
        let companyId = this.$_getSelectedCompanyById as number;
        let idsToExport = this.journeysIds;
        let dateFile;
        if(this.dateFilter.dateRange == null){
            dateFile = this.dateFilter.date
        }else{
            dateFile = this.dateFilter.dateRange.from + "-hasta-" + this.dateFilter.dateRange.to;
        }
        let fileName = "listado_de_jornadas-"
                        + (this.$_getSelectedCompany !== null ? this.$_getSelectedCompany.name.toLowerCase().replace(/ /g, '') : '')
                        + '-' + dateFile ;

        if(this.selectedJourneys.length !== 0){
            idsToExport = this.selectedJourneys.map(function(journey){
                return journey['id']
            })
        }
        let journeysIds = {
            journey_list: idsToExport,
            company_id: companyId
            // journey_list: ['5e7c96c5c7cb4911f9298de9'] //Jornada erronea para testing
        };
        generateExcel(journeysIds, fileName, "list");
    }

    selectAllJourneys(){
        if(this.selectedJourneys.length == 0){
            this.selectedJourneys = this.filteredJourneys;
        }else{
            this.selectedJourneys = [];
        }
    }

    addDurationColumn(){
        //si la columna de duracion no existe, la agrego
        if(this.headersTable.filter(header => header.text === "Duración").length == 0){
            this.headersTable.splice(5, 0, {
                text: 'Duración',
                value: 'current_duration',
                sortable: true
            });
        }
    }

    removeDurationColumn(){
        //si la columna de duracion existe, la elimino
        if(this.headersTable.filter(header => header.text === "Duración").length > 0){
            this.headersTable = this.headersTable.filter(header => header.text !== "Duración");
        }
    }

    getDateRangeInfo(vehicles) {
        this.cancelTokens();
        this.pendingRequest = true;
        const currentToken = this.cancelToken;
        JourneysService.getJourneysListHistorical(
                this.$_getDateRange.datetime_from,
                this.$_getDateRange.datetime_to,
                vehicles,
                currentToken.token
            )
            .then((data) => {
                if (currentToken !== this.cancelToken) {
                    return;
                }
                this.setJourneys(data);
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    return;
                }
                this.handleCatch(error);
            })
            .finally(() => {
                if (currentToken === this.cancelToken) {
                    this.pendingRequest = false;
                }
            });
        }


    getNowInfo(vehicles) {
        this.cancelTokens();
        this.pendingRequest = true;
        const currentToken = this.cancelToken;

        JourneysService.getJourneysListRT(vehicles, false, currentToken.token)
            .then((data) => {
                if (currentToken !== this.cancelToken) {
                    return;
                }
                this.setJourneys(data);
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    return;
                }
                this.handleCatch(error);
            })
            .finally(() => {
                if (currentToken === this.cancelToken) {
                    this.pendingRequest = false;
                }
            });
    }




    getYesterdayOrTodayInfo(vehicles, dateFrom, dateTo) {
        this.cancelTokens();
        this.pendingRequest = true;
        const currentToken = this.cancelToken;
        
        JourneysService.getJourneysListHistorical(
            dateFrom,
            dateTo,
            vehicles,
            currentToken.token
        )
        .then((data) => {
            if (currentToken !== this.cancelToken) {
                return;
            }
            this.setJourneys(data);
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                return;
            }
            this.handleCatch(error);
        })
        .finally(() => {
            if (currentToken === this.cancelToken) {
                this.pendingRequest = false;
            }
        });
    }



    @Watch('$_getFilterDate')
    @Watch('$_getSelectedVehiclesByID')
    getJourneysList() {
        let _this = this;
        
        if(this.$_getFilterDate !== TypeFilterDate.RANGE_DATE){
            this.dataIsLoaded = false;

            this.journeys = [];
            this.journeysIds = [];
            this.dateFilter = {
                date: null,
                dateRange: null
            };
             
            this.pendingRequest = true;
            // if (this.$_existVehiclesSelected()) {
                let vehicles;
                if (this.$_existVehiclesSelected()){
                vehicles = this.$_getSelectedVehiclesByID;
                }else{
                vehicles = this.$_selectVehiclesFromSelectedCompanyById();
                }
                if (this.$_getFilterDate == TypeFilterDate.TR) {
                    // window.console.log("ahora");
                    this.addDurationColumn();
                    this.dateFilter.date = getCurrentTime(dateTypes.dateFormatFromDisplayInfoHyphenMins)
                    this.hideAvailabilityColumn = false;
                    this.hideDurationColumn = false;
                    // this.headers = this.headersRT;
                    this.getNowInfo(vehicles)                    
                } else if (this.$_getFilterDate == TypeFilterDate.TODAY) {
                    // window.console.log("hoy");
                    this.removeDurationColumn()
                    this.dateFilter.date = getCurrentTime(dateTypes.dateFormatFromDisplayInfoHyphen)
                    this.hideAvailabilityColumn = true;
                     this.hideDurationColumn = true;
                    // this.headers = this.headersRT;
                    this.getYesterdayOrTodayInfo(
                        vehicles, 
                        getDateTimeFromToDay(),
                        getDateTimeToToDay()
                    )
                    
                } else if (this.$_getFilterDate == TypeFilterDate.YESTERDAY){
                    this.removeDurationColumn()
                    // window.console.log("ayer");
                    let dateWithLessOneDay = substractTimeToDate(getNowNoFormat(), 1, diffOptions.day);
                    this.dateFilter.date = getDateFormattedAsMoment(dateWithLessOneDay, dateTypes.dateFormatFromDisplayInfoHyphen)
                    this.hideAvailabilityColumn = true;
                    this.hideDurationColumn = true;
                    // this.headers = this.headersRT;
                    this.getYesterdayOrTodayInfo(
                        vehicles, 
                        getDateTimeFromYesterday(),
                        getDateTimeToYesterday(),
                    );
                }
        }else{
            this.removeDurationColumn()
        }
    }

    setJourneys(data) {

        if (!data || !data.journeys) {
            return;
        }

        try {
            if (data.hasOwnProperty('calc_type')) {
                this.journeyCalcType = data.calc_type;
            }

            this.journeys = data.journeys || [];
            this.summary = data.summary || {};
            this.saveJourneysData(data.journeys);
            
            this.dataIsLoaded = true;
            this.clearSelectedJourneys();
        } catch (error) {
            console.error('setJourneys: Error processing data', error);
        }
    }

    handleCatch(error) {
        if (error && error.response) {
            this.dataIsLoaded = true;
        } else if (axios.isCancel(error)) {
            //console.warn('handleCatch: Request was cancelled');
        } else {
            //console.error('handleCatch: Unknown error', error);
        }
    }

    get getModalJourneyAbm(): HTMLFormElement {
        return this.$refs.modalJourneyAbm as HTMLFormElement;
    }

    @Watch('$_getSelectedCompany')
    watchSelectedCompany(){
        this.$_setSelectedVehicles([]);
        this.getModalJourneyAbm.updateModalData();
        this.getDriversFromSelectedCompany();
        this.getJourneysList();

    }

    getDriversFromSelectedCompany(){
        this.cancelToken = axios.CancelToken.source();
        SettingsService.getDriversList(this.$_getSelectedCompanyById as string, false, this.cancelToken)
            .then((data) => {
                let drivers:any = data;
                this.$_setDriversCompany(drivers.sort(sortObjectByPropertyName("name")));
            })
            .catch((err) => {
                // this.$_errorGetRecipients('Error al obtener destinatarios.');
                this.$_setDriversCompany(null);
            });
    }

    saveJourneysData(data){
        this.dataIsLoaded = false;
        this.summaryData = {
            jornadas:0,
            alertas: 0,
            sin_procesar: 0,
            con_error: 0,
            abiertas: 0
        };
        let totalAlertas = 0;
        let arrayAlertas: any = [];
        let jornadasSinProcesar = 0;
        let jornadasConError = 0;
        let jornadasAbiertas = 0;
        for(let i=0; i<data.length; i++){
            this.journeysIds.push(data[i].id);


            if(data[i].summary.alerts.count > 0){
                data[i].summary.alerts['value'] = 1;
            }else{
                data[i].summary.alerts['value'] = 0;
            }

            arrayAlertas.push(data[i].summary.alerts.value);

            if (!data[i].processed) {
                jornadasSinProcesar++;
            }
            if (data[i].error) {
                jornadasConError++;
            }
            if (data[i].datetime_to == null) {
                jornadasAbiertas++;
            }
        }
        for (let b=0; b < arrayAlertas.length; b++) {
            totalAlertas += arrayAlertas[b];
        }

        this.summary = data;
        this.summaryData['journeys'] = data.length;
        this.summaryData['alertas'] = totalAlertas;
        this.summaryData['sin_procesar'] = jornadasSinProcesar;
        this.summaryData['con_error'] = jornadasConError;
        this.summaryData['abiertas'] = jornadasAbiertas;
        this.dataIsLoaded = true;
    }

    mounted() {
        this.$_closeNotification();
        EventBus.$emit(TypeEventBus.CLOSE_DATERANGE_SELECTOR);
        EventBus.$emit(TypeEventBus.NOT_CALL_LAST_REPORT);

        EventBus.$emit(TypeEventBus.RESET_VEHICLES_MAX_SELECTED);
         EventBus.$on(TypeEventBus.CLOSE_MODAL_CONFIRMATION, () => {
            this.showModalConfirmation = false;
        });

        if(existKeyInLocalStorage(StoregeKey.JOURNEYS_LIST_FILTERS)) {
            try {
                this.tableFilters = JSON.parse(getItemFromLocalStorage(StoregeKey.JOURNEYS_LIST_FILTERS) || 'null');
                this.availabilityFilterValue = (this.tableFilters.disponibilidad !== undefined ? this.tableFilters.disponibilidad : 'null');
                this.processedValue = (this.tableFilters.procesadas !== undefined ? this.tableFilters.procesadas : 'null');
                this.journeySelected = (this.tableFilters.marcada_con_error !== undefined ? this.tableFilters.marcada_con_error : 'null');
                this.journeySelectedFinished = (this.tableFilters.finalizadas !== undefined ? this.tableFilters.finalizadas : 'null');
                this.createdByAdmValue = (this.tableFilters.creadas !== undefined ? this.tableFilters.creadas : 'null');
                this.deletedByAdmValue = (this.tableFilters.eliminadas !== undefined ? this.tableFilters.eliminadas : !this.hasParams ? 'false' : 'null');
                this.filterAlertsSelected = (this.tableFilters.alertas !== undefined ? this.tableFilters.alertas : 'null');
                this.search = (this.tableFilters.journey_list_search !== undefined ? this.tableFilters.journey_list_search : '');
            } catch(e) {
                removeItemFromLocalStorage(StoregeKey.JOURNEYS_LIST_FILTERS);
            }
        }else{
            if(!this.hasParams){
                this.deletedByAdmValue = 'false';
            }
        }

        EventBus.$on(TypeEventBus.EXCEL_EXPORT_ERROR, () => {
           this.processingExcel = false;
           this.actionJourney = 'errorExportExcel';
           this.showModalConfirmation = true;
        });
        EventBus.$on(TypeEventBus.EXCEL_GENERATED, () => {
           this.processingExcel = false;
        });
    }

    updateJourneyList(){
        this.showModalAbm = false;
        if(this.$_getFilterDate == TypeFilterDate.RANGE_DATE){
            this.getJourneyDateRange();
        }else{
            this.getJourneysList();
        }
    }

    @Watch('$_getDateRange')
    observableDateRange(){
        if(
            this.$_getFilterDate == TypeFilterDate.RANGE_DATE &&
            this.$_getDateRange.datetime_from !== '' && this.$_getDateRange.datetime_to !== ''
        )
        {
            this.getHistoricalJourneys();
        }
    }
    
    @Watch('$_getSelectedVehiclesByID')
    getJourneyDateRange(){
        let self = this;
        this.journeys = [];
        this.journeysIds = [];
        this.dataIsLoaded = false;
        if (this.$_getFilterDate == TypeFilterDate.RANGE_DATE){
            if(this.$_getDateRange.datetime_from === '' && this.$_getDateRange.datetime_to === ''){
                this.journeys = [];
                
            }else{
                this.dateFilter = {
                    date: null,
                    dateRange: null
                };
                this.dateFilter.dateRange = {
                    from: getDateFormattedAsMoment(this.$_getDateRange.datetime_from, dateTypes.dateFormatFromDisplayInfoHyphenMins),
                    to: getDateFormattedAsMoment(this.$_getDateRange.datetime_to, dateTypes.dateFormatFromDisplayInfoHyphenMins)
                }
                this.hideAvailabilityColumn = true;
                this.getHistoricalJourneys();
            }
        }

        if(this.$_getFilterDate !== TypeFilterDate.TR){
            this.hideDurationColumn = true;
        }
    }

    getHistoricalJourneys(){
        let vehicles = this.$_existVehiclesSelected() ? this.$_getSelectedVehiclesByID : this.$_selectVehiclesFromSelectedCompanyById();
        let self = this;
        this.cancelTokens();

        this.getDateRangeInfo(vehicles);
}   

    format(date: string) {
        return formatDate(date);
    }
}
